module.exports = __webpack_public_path__ + "static/media/experiment-table.c496b858.svg";